var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ローディング
import {
  loading
} from "../include/module";
loading();

//ヘッダーの開閉
import {
  headerToggle
} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {
  anchorScroll
} from "../include/module";
anchorScroll();

// preload
import {
  preload
} from "../include/module";
preload();

// resizing
import {
  resizing
} from "../include/module";
resizing();

// アニメーション
import {
  animationFire
} from "../include/module";
animationFire();

//タブ切り替え
const staff_cast_Tab = () => {
  const $tabNav = $('.staff_cast-Tab').find('li');
  const $st_Wrapper = $('.st-Wrapper');
  $tabNav.on('click', function () {
    $($tabNav).removeClass('current');
    // $(this).addClass('current');
    // $($st_Wrapper).toggleClass('season1');
    // $($st_Wrapper).toggleClass('season2');
    let element = this.className;
    $(this).addClass('current');
    if (element == 'season1') {
      $($st_Wrapper).addClass('season1');
      $($st_Wrapper).removeClass('season2');
      $($st_Wrapper).removeClass('season3');
    } else if (element == 'season2') {
      $($st_Wrapper).addClass('season2');
      $($st_Wrapper).removeClass('season1');
      $($st_Wrapper).removeClass('season3');
    } else if (element == 'season3') {
      $($st_Wrapper).addClass('season3');
      $($st_Wrapper).removeClass('season1');
      $($st_Wrapper).removeClass('season2');
    }
  });
};
staff_cast_Tab();

//スタッフ・キャストのコメントモーダル
const commentModal = () => {
  const $modal = $('.staff_cast_Modal');
  const $content = $('.staff_cast_Modal-Content');
  const $comment = $('.js-staff_cast_Modal');
  const $setArea = $('#staff_cast_Modal-Content').children('.content');
  // open
  $comment.on('click', function () {
    const dataID = $(this).attr('data-id');
    $.ajax({
      url: '/wp/wp-content/themes/anime_heros_ultraman/assets/js/staff_cast/comment.json',
      dataType: 'json',
      cache: false,
      success: function (data) {

        const allData = data;
        const filterData = allData.filter(function (item, index) {
          if (item.itemID == dataID) return true;
        });
        const roleJa = filterData[0].itemRoleJa;
        const roleEn = filterData[0].itemRoleEn;
        const nameJa = filterData[0].itemNameJa;
        const commentJa = filterData[0].itemCommentJa;
        const nameEn = filterData[0].itemNameEn;
        const commentEn = filterData[0].itemCommentEn;
        const image = filterData[0].itemImage;
        let element;

        if (dataID === 'kamiyama-kenji' || dataID === 'kamiyama-kenji_season2' || dataID === 'aramaki-shinji' || dataID === 'aramaki-shinji_season2' || dataID === 'kawana-motoki' || dataID === 'kimura-ryohei' || dataID === 'kimura-ryohei_season2' || dataID === 'kimura-ryohei_season3' || dataID === 'eguchi-takuya' || dataID === 'eguchi-takuya_season2' || dataID === 'eguchi-takuya_season3' || dataID === 'han-megumi' || dataID === 'han-megumi_season2' || dataID === 'han-megumi_season3' || dataID === 'tanaka-hideyuki' || dataID === 'tanaka-hideyuki_season2' || dataID === 'tanaka-hideyuki_season3' || dataID === 'morohoshi-sumire' || dataID === 'morohoshi-sumire_season2' || dataID === 'morohoshi-sumire_season3' || dataID === 'uo-ken' || dataID === 'uo-ken_season2' || dataID === 'ushiyama-shigeru' || dataID === 'ushiyama-shigeru_season2' || dataID === 'takeuchi-ryota' || dataID === 'takeuchi-ryota_season2' || dataID === 'takeuchi-ryota_season3' || dataID === 'hanawa-eiji' || dataID === 'sekido-hirokazu' || dataID === 'tsuda-kenjiro' || dataID === 'tsuda-kenjiro_season2' || dataID === 'shiraishi-minoru' || dataID === 'shiraishi-minoru_season2' || dataID === 'soze-kaiji' || dataID === 'soze-kaiji_season2' || dataID === 'yamazaki-katsuyuki' || dataID === 'kasahara-shinji' || dataID === 'shibai-haruka' || dataID === 'ogawa-teruaki' || dataID === 'soze-kaiji_2' || dataID === 'suwabe-junichi_season2' || dataID === 'maeno-tomoaki_season2' || dataID === 'maeno-tomoaki_season3' || dataID === 'sakamoto-maaya_season2' || dataID === 'sakura-ayane_season2' || dataID === 'kasahara-shinji_season2' || dataID === 'ogawa-teruaki_season2' || dataID === 'soze-kaiji_motion_season2' || dataID === 'kawana-motoki_season2' || dataID === 'kawana-motoki_season3' || dataID === 'okada-chihei_season2' || dataID === 'ueda-rie_season2' || dataID === 'furuya-takashi_season2' || dataID === 'hara-ryuta_season2' || dataID === 'suzuki-daiki_season2' || dataID === 'naoki-tasaki_season2' || dataID == `mao_season3` || dataID === 'ishii-koji_season3' || dataID === 'ryutaro-yamasaki_motion_season3' || dataID === 'hiroshi-yamanaka_motion_season3' || dataID === 'yamato-takaba_motion_season3' || dataID === 'rin-matsubara_motion_season3' || dataID === 'akihisa-muramoto_motion_season3' || dataID === 'akane-tani_motion_season3') {
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body with-image"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + image + '.jpg"></div><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div></div>'
        } else if (dataID === 'kamiyama-kenji_season3' || dataID === 'aramaki-shinji_season3' || dataID === 'music_season3') {
          const profileJa = filterData[0].itemProfileJa;
          const profileEn = filterData[0].itemProfileEn;
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body with-image"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + image + '.jpg"></div><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div></div><div class="body"><div class="profile"><h3>PROFILE</h3><p class="ja">' + profileJa + '</p><p class="en">' + profileEn + '</p></div></div>'
        } else if (dataID === 'music' || dataID === 'music_season2') {
          const profileJa = filterData[0].itemProfileJa;
          const profileEn = filterData[0].itemProfileEn;
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body"><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div><div class="profile"><h3>PROFILE</h3><p class="ja">' + profileJa + '</p><p class="en">' + profileEn + '</p></div></div>'
        } else if (dataID === 'hirata-hiroaki' || dataID === 'shingaki-tarusuke') {
          const profileJa = filterData[0].itemProfileJa;
          const profileEn = filterData[0].itemProfileEn;
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body"><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div>'
        } else if (dataID === 'oldcodex') {
          const commenter = filterData[0].itemCommenter;
          const commentJa_2 = filterData[0].itemCommentJa_2;
          const commenter2 = filterData[0].itemCommenter2;
          const commentJa2 = filterData[0].itemCommentJa2;
          const commentJa2_2 = filterData[0].itemCommentJa2_2;
          const commentEn2 = filterData[0].itemCommentEn2;
          const profileJa = filterData[0].itemProfileJa;
          const profileEn = filterData[0].itemProfileEn;
          const songTitle = filterData[0].itemSongTitle;
          const songTitle2 = filterData[0].itemSongTitle2;
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body oldcodex"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + dataID + '_2.png"><p class="song-title">' + songTitle2 + '</p></div><div class="comment"><h3>' + commenter + '</h3><p class="ja">' + commentJa_2 + '</p></div><div class="comment"><h3>' + commenter2 + '</h3><p class="ja">' + commentJa2_2 + '</p></div></div><div class="body oldcodex"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + dataID + '.png"><p class="song-title">' + songTitle + '</p></div><div class="comment"><h3>' + commenter + '</h3><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div><div class="comment"><h3>' + commenter2 + '</h3><p class="ja">' + commentJa2 + '</p><p class="en">' + commentEn2 + '</p></div><div class="profile"><h3>PROFILE</h3><p class="ja">' + profileJa + '</p><p class="en">' + profileEn + '</p></div></div>'
        } else if (dataID === 'void_chords' || dataID === 'void_chords_season2' || dataID === 'void_chords_season3') {
          const songTitle = filterData[0].itemSongTitle;
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body oldcodex"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + image + '.png"><p class="song-title">' + songTitle + '</p></div><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div></div>'
        } else if (dataID === 'noilion' || 'noilion_season3') {
          const profileJa = filterData[0].itemProfileJa;
          const profileEn = filterData[0].itemProfileEn;
          const songTitle = filterData[0].itemSongTitle;
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body oldcodex"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + dataID + '.png"><p class="song-title">' + songTitle + '</p></div><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div><div class="profile"><h3>PROFILE</h3><p class="ja">' + profileJa + '</p><p class="en">' + profileEn + '</p></div></div>'
        } else if (dataID === 'miyavi_season3') {
          const profileJa = filterData[0].itemProfileJa;
          const profileEn = filterData[0].itemProfileEn;
          const songTitle = filterData[0].itemSongTitle;
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body oldcodex"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + dataID + '.png"><p class="song-title">' + songTitle + '</p></div><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div><div class="profile"><h3>PROFILE</h3><p class="ja">' + profileJa + '</p><p class="en">' + profileEn + '</p></div></div>'
        } else {
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body"><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div></div>'
        }

        $(element).appendTo($setArea);

        // else if(dataID === 'yamazaki-katsuyuki'){
        //   element = '<dl><dt><span class="ja">' + roleJa + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span></p></div></dd></dl><div class="body"><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div></div>'
        // }
      }
    });


    $modal.stop().fadeIn(400);
    return false;
  });
  //close
  $('.staff_cast_Modal-Overlay,.staff_cast_Modal-Close').on('click', function () {
    $modal.stop().fadeOut(400, function () {
      $setArea.children().remove();
    });
  });
};
commentModal();


// WEBPACK FOOTER //
// ./src/assets/js/staff_cast/script.js